import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  HiOutlineHome,
  HiOutlineFolder,
  HiOutlineCalendar,
  HiOutlineDocumentText,
  HiOutlineChartPie,
  HiOutlineLogout,
  HiOutlineCurrencyDollar,
} from "react-icons/hi";
import Header from "../components/Header";
import Footer from "../components/Footer";
import DashboardHome from "../components/DashboardHome";
import { useSiteConfig } from "../components/SiteConfigContext";
import AssetOverview from "./AssetOverview";
import AssetSpot from "./AssetSpot";
import AssetEarn from "./AssetEarn";
import EarnPlans from "./EarnPlans";
import Rewards from "./Rewards";
import Account from "./Account";
import Security from "../pages/Security";
import SpotOrder from "./SpotOrder";
import P2pOrder from "./P2pOrder";
import TransactionHistory from "./TransactionHistory";
import ReferralDashboard from "./ReferralDashboard";

const icons = {
  Dashboard: HiOutlineHome,
  Assets: HiOutlineFolder,
  Orders: HiOutlineFolder,
  "Earn Plans": HiOutlineCurrencyDollar,
  Rewards: HiOutlineCalendar,
  Referral: HiOutlineDocumentText,
  Accounts: HiOutlineChartPie,
  Security: HiOutlineChartPie,
};

const itemClass = "ud-menu-btn";

const Dashboard = () => {
  const { userMenuItems } = useSiteConfig();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const [open, setOpen] = useState({ Assets: true, Orders: false });
  const activeTab = params.get("tab") || "dashboard";

  const selectTab = (tab) => setParams({ tab });

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <div className="ud-shell transition-colors duration-300">
      <Header />
      <section className="flex p-0">
        <div className="lg:flex py-6 pl-4 hidden">
          <div className="w-56 flex flex-col justify-between">
            <nav className="space-y-1">
              {userMenuItems.map((item) => {
                const Icon = icons[item.name] || HiOutlineFolder;
                if (item.children?.length) {
                  return (
                    <div key={item.name}>
                      <div
                        onClick={() => setOpen({ ...open, [item.name]: !open[item.name] })}
                        className={`${itemClass} justify-between cursor-pointer`}
                      >
                        <div className="flex items-center gap-3">
                          <Icon className="w-5 h-5" />
                          {item.name}
                        </div>
                        <span>{open[item.name] ? "▲" : "▼"}</span>
                      </div>
                      {open[item.name] && (
                        <div className="ml-8 mt-1 space-y-1">
                          {item.children.map((sub) => (
                            <button
                              key={sub.name}
                              onClick={() => selectTab(sub.tab)}
                              className={`ud-menu-btn text-sm ${activeTab === sub.tab ? "active" : ""}`}
                            >
                              {sub.name}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                }
                return (
                  <button
                    key={item.name}
                    onClick={() => selectTab(item.tab)}
                    className={`${itemClass} ${activeTab === item.tab ? "active" : ""}`}
                  >
                    <Icon className="w-5 h-5" />
                    {item.name}
                  </button>
                );
              })}
            </nav>

            <div className="px-2 py-4">
              <button
                onClick={logout}
                className="ud-menu-btn"
              >
                <HiOutlineLogout className="w-5 h-5" />
                Logout
              </button>
            </div>
          </div>
        </div>

        <div className="flex-1 p-6 w-full">
          {activeTab === "dashboard" && <DashboardHome />}
          {activeTab === "overview" && <AssetOverview />}
          {activeTab === "spot" && <AssetSpot />}
          {activeTab === "earn" && <AssetEarn />}
          {activeTab === "earn plans" && <EarnPlans />}
          {activeTab === "ReferralDashboard" && <ReferralDashboard embedded />}
          {activeTab === "rewards" && <Rewards />}
          {activeTab === "account" && <Account />}
          {activeTab === "security" && <Security />}
          {activeTab === "spot orders" && <SpotOrder />}
          {activeTab === "p2p order" && <P2pOrder embedded />}
          {activeTab === "transaction history" && <TransactionHistory />}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Dashboard;
